import { Info } from "@tamagui/lucide-icons";
import { Label, XStack, YStack } from "tamagui";

export const BusinessInfoRow = ({
  title,
}: {
  title: string;
  fullText?: string;
}) => {
  return (
    <YStack
      gap={"$medium"}
      marginVertical={"$medium"}
      paddingHorizontal={"$larger"}
      $gtSm={{ paddingHorizontal: 0 }}
    >
      <XStack gap={"$small"} alignItems={"center"}>
        <Info color={"$muted"} size={20} flexShrink={0} />
        <Label color={"$muted"}>{title}</Label>
      </XStack>
    </YStack>
  );
};
